import { FC } from 'react';

import {
  serializationOptionsForBooleanValue,
  serializationOptionsForNumberValue,
  serializationOptionsForStringValue,
  useSearchParamState,
} from 'utils/hooks/useSearchParamState';

import { TEMPLATE_EDITOR_QUERY_PARAMS } from '../common/constants';
import { TemplateEditViews } from '../common/types';
import { QueryParamContext, QueryParamContextState } from './QueryParamContext';

export const QueryParamContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [campaignId, setCampaignId] = useSearchParamState({
    searchParamKey: TEMPLATE_EDITOR_QUERY_PARAMS.campaignId,
    stateValueWhenSearchParamIsUnset: 0,
    pushChangesToBrowserHistory: false,
    ...serializationOptionsForNumberValue,
  });

  const [experimentFlow] = useSearchParamState({
    searchParamKey: TEMPLATE_EDITOR_QUERY_PARAMS.experimentFlow,
    stateValueWhenSearchParamIsUnset: false,
    pushChangesToBrowserHistory: false,
    ...serializationOptionsForBooleanValue,
  });

  const [locale, setLocale] = useSearchParamState({
    searchParamKey: TEMPLATE_EDITOR_QUERY_PARAMS.locale,
    stateValueWhenSearchParamIsUnset: '',
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForStringValue,
  });

  const [templateId, setTemplateId] = useSearchParamState({
    searchParamKey: TEMPLATE_EDITOR_QUERY_PARAMS.templateId,
    stateValueWhenSearchParamIsUnset: 0,
    pushChangesToBrowserHistory: true,
    ...serializationOptionsForNumberValue,
  });

  const [view, setView] = useSearchParamState({
    searchParamKey: TEMPLATE_EDITOR_QUERY_PARAMS.view,
    stateValueWhenSearchParamIsUnset: TemplateEditViews.settings,
    pushChangesToBrowserHistory: false,
    ...serializationOptionsForStringValue,
  });

  const [workflowNodeFlow] = useSearchParamState({
    searchParamKey: TEMPLATE_EDITOR_QUERY_PARAMS.workflowNodeFlow,
    stateValueWhenSearchParamIsUnset: false,
    pushChangesToBrowserHistory: false,
    ...serializationOptionsForBooleanValue,
  });

  const context: QueryParamContextState = {
    campaignId,
    experimentFlow,
    isJourneyAssociated: false,
    locale,
    setCampaignId,
    setLocale,
    setTemplateId,
    setView,
    templateId,
    view,
    workflowNodeFlow,
  };

  return <QueryParamContext.Provider value={context}>{children}</QueryParamContext.Provider>;
};
